import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';

function AdminLoginPage() {
    const [userData, setUserData] = useState({});
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;

    const handleChange = (e) => {
        setUserData({
            ...userData,
            [e.target.name]: e.target.value
        });
    };

    const handleAdminLogin = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post(`${apiUrl}/admin-login`, userData);
            console.log(response.data);
            console.log(response.status);

            if (response.status === 200) {
                localStorage.setItem('authToken', response.data.token);
                alert('Login successful');
                navigate('/admin');
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                alert(error.response.data.message);
            } else {
                console.error('Error logging in:', error);
                alert('Something went wrong. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modern-login-container">
            {/* Left Panel: Themed Image & Welcome text */}
            <div className="login-left-pane">
                <div className="login-left-content">
                    <h1 className="login-left-title">
                        KIPPS <span>SWEETS</span>
                    </h1>
                    <p className="login-left-subtitle">
                        Crafting Sweet Moments Since 1958. Sign in to your administrator portal to manage your store's products, categories, brands, orders, and configurations.
                    </p>
                </div>
            </div>

            {/* Right Panel: Login Form */}
            <div className="login-right-pane">
                {/* Background Glow */}
                <div className="bg-glow bg-glow-1"></div>
                
                <div className="modern-login-card">
                    <div className="text-center mb-4">
                        <img src='/logo.png' alt='logo' className="login-logo mb-2" />
                        <h4 className="login-title">ADMIN LOGIN</h4>
                    </div>

                    <form onSubmit={handleAdminLogin}>
                        <div className="modern-input-group mb-3">
                            <div className="input-icon-wrapper">
                                <FaUser className="input-icon-left" />
                            </div>
                            <input 
                                type="text" 
                                className="modern-input"
                                placeholder="Enter username" 
                                name="username" 
                                required
                                onChange={handleChange} 
                            />
                        </div>

                        <div className="modern-input-group mb-4">
                            <div className="input-icon-wrapper">
                                <FaLock className="input-icon-left" />
                            </div>
                            <input 
                                type={showPassword ? "text" : "password"} 
                                className="modern-input"
                                placeholder="Enter your password" 
                                name="password" 
                                required
                                onChange={handleChange} 
                            />
                            <button 
                                type="button" 
                                className="password-toggle-btn"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>

                        <button type="submit" className="modern-login-btn" disabled={loading}>
                            {loading ? (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            ) : (
                                'LOGIN'
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AdminLoginPage;
